import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";

import { HiArrowNarrowRight } from "react-icons/hi";


const Servicesfaqs = [
  {
    question: "What is the Akscel Data Platform?",
    answer:
      "The Akscel Data Platform is a cloud-native, metadata-driven analytics tool that automates data ingestion, curation, and processing. It consolidates data from various sources to provide a comprehensive, 360-degree view, enabling real-time insights and smarter decision-making.",
  },
  {
    question: "What industries benefit from data and analytics solutions?",
    answer:
      "Our solutions cater to industries such as finance, healthcare, retail, manufacturing, and technology, offering scalable strategies for diverse data needs.",
  },
  {
    question: "Why is cloud-native analytics important?",
    answer:
      "Cloud-native analytics platforms like Akscel ensure cost-effectiveness, scalability, and real-time processing. These benefits enhance efficiency and adaptability in a data-driven world.",
  },
  {
    question: "How does predictive analytics help my business?",
    answer:
      "Predictive analytics identify trends and patterns, enabling proactive decision-making. By anticipating challenges and opportunities, businesses can strategize more effectively.",
  },
];

const DataAndAnalyticalSolutions = () => {
   const navigate = useNavigate();

    const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`
    
      const handleToggle = (index) => {
        ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };
  
  
  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>{" "}
            Data and Analytical Solutions
          </h5>
          <h2>Turn Data into Actionable Insights</h2>
          <p>
            Gain a 360-degree view of your data with cutting-edge tools designed
            to optimize operations, drive growth, and enhance decision-making.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Schedule a Free Demo
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as Part of Our Data and Analytics Services</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Akscel Data Platform:
                </span>{" "}
                At the heart of our solutions lies the Akscel Data Platform—a
                cloud-native, metadata-driven analytics platform. It automates
                data ingestion, curation, and processing from multiple sources,
                providing a unified, 360-degree view of your data. With Akscel,
                businesses unlock real-time insights and streamline
                decision-making.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Comprehensive Data Management:
                </span>{" "}
                We organize, integrate, and optimize your data to ensure
                accuracy and accessibility. Combined with the power of cloud
                optimization tools, we provide seamless scalability and enhanced
                performance.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Advanced Analytics and Insights:
                </span>{" "}
                Our analytics solutions leverage modern techniques to transform
                raw data into actionable insights. Use predictive analytics to
                forecast trends and prescriptive analytics to identify optimal
                strategies.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Cloud-Based Analytics Solutions:
                </span>{" "}
                Maximize efficiency with cloud-native analytics powered by our
                expertise in cloud optimization services. Integrate with
                platforms like AWS for cost-effective and high-performance data
                processing.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>
            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom Dashboards and Reporting:
                </span>{" "}
                Design personalized dashboards to monitor critical metrics in
                real time. Gain clarity with Customize reporting tools that
                align with your unique business objectives.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Schedule a Free Demo
              <HiArrowNarrowRight className="psec1arrow" />
              {/* <MdArrowRightAlt className="psec1arrow" /> */}
            </button>
          </section>
        </section>

        <section>
          <img
            className="s_sec2_img1"
            src="../images/S_DataAnal_img.png"
            alt=""
          />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil’s Data and Analytics Solutions?</h2>
          <p>
            At Arshil, we provide comprehensive, data-driven solutions that help
            businesses unlock the full potential of their data. Our approach,
            powered by the Akscel Data Platform, ensures that your business can
            make strategic decisions with confidence. Here's why businesses
            trust us:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_d_sec3_img1.png" alt="" />
            <h5>Powered By Akscel data platform</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_d_sec3_img2.png" alt="" />
            <h5>Scalable Strategies</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_d_sec3_img3.png" alt="" />
            <h5>End-to-End Expertise</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_d_sec3_img4.png" alt="" />
            <h5> Secure and Reliable </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/24_7img.png" alt="" />
            <h5> 24/7 support </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_d_sec3_img6.png" alt="" />
            <h5> Continuous support </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to Providing Data and Analytics Solutions</h1>

        <ul className="Service_sec4_ul">
          <li>Discovery and Assessment </li>
          <li>Data Strategy Design</li>
          <li>Implementation and Integration</li>
          <li>Training and Enablement</li>
          <li>Ongoing Support and Optimization</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      <div className="Sec8_container">
        <section>
          <h1>Ready to Obtain Actionable Insights from Your Data?</h1>
          <p>
            Harness the power of the Akscel Data Platform today. Contact Arshil
            to redefine how your business uses data.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Schedule a Free Demo
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default DataAndAnalyticalSolutions;
